import axios from '@/utils/axios'

const API = {
  init: '/remind/ajaxInit',
  setModule: '/remind/ajaxSetRemindConfig'
}

function initPagePost () {
  return axios.post(API.init)
}

function setModulePost (param) {
  return axios.post(API.setModule, param)
}

export {
  initPagePost,
  setModulePost
}
